@if (isLoading) {
  <loading class="pos-fix vh-center"
  ></loading>
}
<!--old cart UI -->
@if (!newCartUI && !isLoading) {
  @if (!noProductsInCart) {
    <div class="tw-flex tw-flex-col tw-h-full tw-bg-gray-100"
      >
      <!--      old cart header -->
      @if (orderFlowHeader) {
        <header class="tw-sticky tw-top-0 tw-z-40 tw-bg-white">
          <div class="tw-relative tw-flex tw-items-center tw-justify-center tw-px-6 tw-py-3">
            <div class="tw-absolute tw-left-6 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-text-gray-800" (click)="back()">
              <cs-icon class="tw-h-full tw-w-full"
              [iconName]="'arrow_left'"></cs-icon>
            </div>
            @if (totalProducts === 1) {
              <h1
                class="tw-text-center tw-text-300 tw-font-bold tw-font-lexend tw-text-gray-800"
                i18n="@@productInYourCart"
              >{{totalProducts}} product in your cart</h1>
            }
            @if (totalProducts > 1) {
              <h1
                class="tw-text-center tw-text-300 tw-font-bold tw-font-lexend tw-text-gray-800"
                i18n="@@productsInYourCart"
              >{{totalProducts}} products in your cart</h1>
            }
          </div>
          <app-order-flow-steps [activeStep]="OrderFlowStep.CART"></app-order-flow-steps>
        </header>
      } @else {
        <header class="tw-sticky tw-top-0 tw-z-40">
          <div class=" tw-flex tw-justify-between tw-items-end tw-bg-white tw-py-2 tw-pb-[10px] tw-px-[27px] tw-relative tw-h-[60px] tw-shadow-z4">
            <div class="tw-w-[16px] tw-aspect-square tw-flex tw-justify-center tw-items-center tw-absolute"  (click)="back()">
              <cs-icon class="tw-h-full tw-w-full tw-text-white"
              [iconName]="'back_new_icon'"></cs-icon>
            </div>
            <div class="tw-flex-1 tw-flex tw-justify-center tw-items-center">
              @if (totalProducts === 1) {
                <h1
                  class="tw-text-center tw-text-300 tw-font-semibold tw-w-full tw-capitalize tw-font-body"
                  i18n="@@productInYourCart"
                >{{totalProducts}} product in your cart</h1>
              }
              @if (totalProducts > 1) {
                <h1
                  class="tw-text-center tw-text-300 tw-font-semibold tw-w-full tw-capitalize tw-font-body"
                  i18n="@@productsInYourCart"
                >{{totalProducts}} products in your cart</h1>
              }
            </div>
          </div>
        </header>
      }
      <!--    scrollable container-->
      <div id="newCartUIContainer" class="tw-flex-1 tw-overflow-y-auto tw-flex tw-flex-col tw-pt-[18px]"
        >
        @if (!isLoading) {
          <div class="tw-mt-0 tw-pb-[41px]">
            <!--when AOV Experiment is false show below product cards of cart-->
            @if (!aovExp) {
              @for (item of cartItems; track item; let i = $index) {
                @if (orderFlowHeader) {
                  <ng-container [ngTemplateOutlet]="orderFlowProductCard" [ngTemplateOutletContext]="{ item: item }"></ng-container>
                } @else {
                <div class="tw-relative tw-flex tw-mx-[23px] tw-mb-[18px] tw-bg-[#ffffff] tw-bg-[position:0_0] tw-bg-no-repeat tw-bg-clip-padding tw-opacity-100 tw-overflow-hidden tw-pb-0 tw-border tw-border-solid tw-border-[#E0E0E0] tw-rounded-5"
                  style="width: -webkit-fill-available; box-shadow: unset;">
                  <img class="tw-w-2/5"
                    (click)="viewProductDetail(item)"
                    [src]="item.rebrandedImageWithBackground || item.rebrandedImage || item.rebrandedImageWithoutBackground || item.imageURL" />
                  @if (item?.price !== 0) {
                    <span class="tw-ml-3 tw-m-4 tw-mr-5 tw-flex tw-flex-col tw-flex-nowrap tw-justify-evenly"
                      [ngClass]="{ '!tw-mt-[30px]' : item?.isDoctorAdded }"
                      style="width: -webkit-fill-available;">
                      @if (item?.isDoctorAdded) {
                        <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-p-2 tw-bg-gray-100 tw-h-6 tw-rounded-t-[25px] tw-rounded-r-[0px] tw-rounded-b-[0px] tw-rounded-l-[25px] tw-absolute tw-right-0 tw-top-2"
                          >
                          <cs-icon class="tw-h-3 tw-w-3 tw-text-white tw-bg-green-400 tw-rounded-full"
                          [iconName]='"done"'></cs-icon>
                          <p class="tw-font-body tw-text-100 tw-text-blue-500 tw-h-6 tw-tracking-[0] tw-font-bold tw-text-[10px] tw-pt-1"
                            i18n="@@drSuggested">
                                Dr. Suggested
                            </p>
                        </div>
                      }
                      <p class="p1-new font12 tw-font-body">{{item?.product?.title || item?.title}}</p>
                      <p class="font12 tw-font-body">{{item?.quantityData}}</p>
                      <span>
                        <del class="pR5 fw-700 font14 tw-font-body">₹{{item?.mrp}}</del>
                        <span class="fw-700 clr-orange font14 tw-font-body">₹{{item?.price}}</span>
                      </span>
                      <span class="tw-mt-[13px] tw-h-8 flex">
                        <div
                          class="tw-flex tw-w-[93px] tw-h-[25px] tw-opacity-100 tw-justify-around tw-bg-[#FEFEFE] tw-border tw-border-solid tw-border-[#5FA653] tw-rounded-6 tw-text-[#5FA653] tw-mr-2">
                          <em class="cs-icon-minus green"
                          (click)='removeProduct(item, "REMOVE", $event)'></em>
                          @if (!item.isRx) {
                            <b class="tw-h-[18px] tw-text-left tw-text-[14px] tw-tracking-[0px] green"
                            >{{item?.quantity > nonRxLimit ? nonRxLimit :item?.quantity}}</b>
                          }
                          @if (item.isRx) {
                            <b class="tw-h-[18px] tw-text-left tw-text-[14px] tw-tracking-[0px] green"
                            >{{item?.quantity > rxLimit ? rxLimit : item?.quantity}}</b>
                          }
                          <em class="cs-icon-plus green"
                          (click)='addOrRemove(item, "ADD", $event)'></em>
                        </div>
                        <p class="font12 tw-font-body"
                          i18n="@@remove"
                          (click)='removeProduct(item, "DELETE", $event)'
                          style="margin: unset; margin-right: 17px;">
                                Remove
                            </p>
                      </span>
                    </span>
                  }
                </div>
                }
              }
            }
            @if (aovExp && isAOVActive) {
              @if (shouldShowAovFreeProductFirst) {
                <ng-container [ngTemplateOutlet]="orderFlowFreeProductCard"></ng-container>
              }
              @for (item of ( (this.totalSP >= this.maxPrice.totalValue && showFreeProd && !noFreeProduct) ? (cartItems | slice: 0: cartItems.length - 1) : (cartItems) ); track item; let i = $index) {
                @if (orderFlowHeader) {
                  <ng-container [ngTemplateOutlet]="orderFlowProductCard" [ngTemplateOutletContext]="{ item: item }"></ng-container>
                } @else {
                @if (item?.price !== 0) {
                  <div class="align-center tw-relative tw-flex tw-mx-[23px] tw-mb-[18px] tw-bg-[#ffffff] tw-bg-[position:0_0] tw-bg-no-repeat tw-bg-clip-padding tw-opacity-100 tw-overflow-hidden tw-pb-0 tw-border tw-border-solid tw-border-[#E0E0E0] tw-rounded-5"
                    style="width: -webkit-fill-available; box-shadow: unset;">
                    <img class="tw-mr-[5px] tw-object-contain tw-rounded-tl-5 tw-rounded-br-5 tw-w-2/5"
                      (click)="viewProductDetail(item)"
                      [src]="item.rebrandedImageWithBackground || item.rebrandedImage || item.rebrandedImageWithoutBackground || item.imageURL" />@if (item?.price !== 0) {
                      <span
                        class="tw-ml-3 tw-mr-5 tw-flex tw-flex-col tw-flex-nowrap tw-justify-evenly tw-m-4"
                        [ngClass]="{ '!tw-mt-[30px]' : item?.isDoctorAdded }"
                        >
                      @if (item?.isDoctorAdded) {
                        <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-p-2 tw-bg-gray-100 tw-h-6 tw-rounded-t-[25px] tw-rounded-r-[0px] tw-rounded-b-[0px] tw-rounded-l-[25px] tw-absolute tw-right-0 tw-top-2"
                          >
                          <cs-icon class="tw-h-3 tw-w-3 tw-text-white tw-bg-green-400 tw-rounded-full"
                          [iconName]='"done"'></cs-icon>
                          <p class="tw-font-body tw-text-100 tw-text-blue-500 tw-h-6 tw-tracking-[0] tw-font-bold tw-text-[10px] tw-pt-1"
                            i18n="@@drSuggested">
                                Dr. Suggested
                            </p>
                        </div>
                      }
                      <p class="p1-new font12 tw-font-body">{{item?.product?.title || item?.title}}</p>
                      <p class="font12 tw-font-body">{{item?.quantityData}}</p>
                      <span><del class="pR5 fw-700 font14 tw-font-body">₹{{item?.mrp}}</del><span
                    class="fw-700 clr-orange font14 tw-font-body">₹{{item?.price}}</span></span>
                    <span class="tw-mt-[13px] tw-h-8 flex tw-gap-3">
                      <div
                        class="tw-flex tw-w-[93px] tw-h-[25px] tw-opacity-100 tw-justify-around tw-bg-[#FEFEFE] tw-border tw-border-solid tw-border-[#5FA653] tw-rounded-6 tw-text-[#5FA653] tw-mr-2">
                        <em class="cs-icon-minus green"
                        (click)='removeProduct(item, "REMOVE", $event)'></em>
                        @if (!item.isRx) {
                          <b class="tw-h-[18px] tw-text-left tw-text-[14px] tw-tracking-[0px] green"
                          >{{item?.quantity > nonRxLimit ? nonRxLimit :item?.quantity}}</b>
                        }
                        @if (item.isRx) {
                          <b class="tw-h-[18px] tw-text-left tw-text-[14px] tw-tracking-[0px] green"
                          >{{item?.quantity > rxLimit ? rxLimit : item?.quantity}}</b>
                          }<em
                          class="cs-icon-plus green"
                        (click)='addOrRemove(item, "ADD", $event)'></em>
                      </div>
                      <p class="font12"
                        i18n="@@remove"
                        (click)='removeProduct(item, "DELETE", $event)'
                        style="margin: unset">
                                Remove
                            </p>
                    </span>
                  </span>
                }
              </div>
            }
            }
          }
          @if (shouldShowAovFreeProductLast) {
            <div class="tw-flex tw-mx-[23px] tw-mb-[18px] tw-overflow-hidden tw-bg-[#FFF0F0] tw-bg-[position:0_0] tw-bg-no-repeat tw-bg-clip-padding tw-shadow-z2 tw-opacity-100 tw-pb-0 tw-border tw-border-solid tw-border-[#E0E0E0] tw-rounded-5"
              style="width: -webkit-fill-available; box-shadow: unset;">
              <img class="tw-mr-[5px] tw-object-contain tw-rounded-tl-5 tw-rounded-br-5 tw-w-2/5"
                [src]="freeProductImageForAov" />
              <span class="tw-ml-3 tw-mr-5 tw-flex tw-flex-col tw-flex-nowrap tw-justify-evenly m16">
                <p class="p1-new font12 tw-font-body">{{freeProduct?.title}}</p>
                <p class="font12 tw-font-body">
                  {{freeProduct?.quantity}} {{freeProduct?.quantityUnit}}
                </p>
                <span class="tw-justify-between tw-mt-[13px] tw-h-8 flex">
                  <p class="tw-text-red-400 font14 fw-700 clr-orange tw-font-body tw-uppercase"
                  i18n="@@free">free</p>
                </span>
              </span>
            </div>
          }
        }
        <!--  old cart new non sticky bill details container-->
        @if (!isLoading) {
          <section>
            <!--          aov old cart non sticky -->
            @if (aovExp && isAOVActive && amountRemaining && amountRemaining > 0 && !isLoading) {
              <div class="tw-font-body tw-text-200 tw-bg-gradient-skin-and-white tw-mx-4 tw-mb-4 tw-rounded-3 tw-p-2">
                <div class="tw-text-center">
                  <span class=""
                    i18n="@@shopMore">
                Shop for ₹{{ amountRemaining%1 != 0 ? amountRemaining.toFixed(2) :
                amountRemaining }} more to
              </span>
                  <span class="tw-ml-0.5"
                    i18n="@@getAFreeGift">
                    <p class="tw-lowercase tw-inline-block">Get a</p>
                    <p class="tw-inline-block tw-px-[3px]">free</p>
                    <p class="tw-lowercase tw-inline-block">product</p>
                </span>
                </div>
                <div class="tw-flex tw-items-center tw-justify-center">
                  <p class="tw-text-center tw-capitalize tw-font-[700] tw-text-teal-600" (click)="goToList()" i18n="@@addMoreProducts">
                Add more products
              </p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="mask0_43790_65110" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                      <rect width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_43790_65110)">
                      <path d="M12.9467 12L8.8735 7.92701C8.73517 7.78851 8.66433 7.61443 8.661 7.40476C8.65783 7.19526 8.72867 7.01801 8.8735 6.87301C9.0185 6.72818 9.19417 6.65576 9.4005 6.65576C9.60683 6.65576 9.7825 6.72818 9.9275 6.87301L14.4217 11.3673C14.5152 11.4609 14.5813 11.5597 14.6198 11.6635C14.6583 11.7673 14.6775 11.8795 14.6775 12C14.6775 12.1205 14.6583 12.2327 14.6198 12.3365C14.5813 12.4403 14.5152 12.5391 14.4217 12.6328L9.9275 17.127C9.789 17.2653 9.61492 17.3362 9.40525 17.3395C9.19575 17.3427 9.0185 17.2718 8.8735 17.127C8.72867 16.982 8.65625 16.8063 8.65625 16.6C8.65625 16.3937 8.72867 16.218 8.8735 16.073L12.9467 12Z" fill="#0E796C"/>
                    </g>
                  </svg>
                </div>
              </div>
            }
            <!--          Bill container old cart non sticky-->
            <div #billDetailsContainer class="tw-rounded-2 tw-shadow-z4 tw-bg-white tw-pt-5 tw-mx-4">
              <!--    section title-->
              <div class="tw-flex tw-gap-[6px] tw-relative tw-px-4 tw-pb-3">
                <cs-icon class="tw-h-5 tw-text-white tw-aspect-square" [iconName]="'bill_icon'"></cs-icon>
                <h1 class=" tw-font-bold tw-text-300" i18n="@@billDetails">Bill Details</h1>
                <div class="tw-absolute tw-w-[90%] tw-border-b-[1px] tw-border-gray-200 tw-border-dashed tw-left-1/2 tw-bottom-0 tw-transform tw-translate-y-[1px] -tw-translate-x-1/2"></div>
              </div>
              <!--    details container-->
              <div class="tw-text-200 tw-font-body tw-pt-[2px]">
                <!--      sub details container-->
                <div class="tw-py-3 tw-relative tw-px-4">
                  <!--      subtotal-->
                  <div class="tw-flex tw-justify-between tw-items-center tw-mb-2">
                    <span i18n="@@subtotal" class="tw-text-gray-800  ">Subtotal</span>
                    <span class="tw-tabular-nums  ">₹{{totalMRP}}</span>
                  </div>
                  <!--      Discount-->
                  <div class="tw-flex tw-justify-between tw-items-center tw-mb-2">
                    <span i18n="@@discount" class="tw-text-gray-800  ">Discount</span>
                    <div class="tw-flex tw-items-center tw-text-orange-500">
                      @if (!showCashBalance) {
                        <span class="tw-tracking-[1px] tw-tabular-nums">- ₹{{totalMRP - totalSP}}</span>
                      }
                      @if (showCashBalance) {
                        <span class="tw-tabular-nums tw-tracking-[1px] ">- ₹{{totalMRP - (totalSP + cashBalance)}}</span>
                      }
                    </div>
                  </div>
                  <!--      Cureskin Cash-->
                  @if (showCashBalance) {
                    <div class="tw-flex tw-justify-between tw-mb-2 tw-items-center "
                      >
                      <span class="tw-flex  ">
                        <span i18n="@@cureskinCash" class="tw-text-gray-800 ">Cure Cash</span>
                        <img class="tw-w-4 tw-ml-1 tw-h-4 " src="/assets/images/cureskin-cash-icon.png" />
                      </span>
                      <span class="tw-tracking-[1px] tw-text-orange-500 tw-tabular-nums ">-₹{{cashBalance}}</span>
                    </div>
                  }
                  <!--      Delivery-->
                  <div class="tw-flex tw-items-center tw-justify-between ">
                    <span i18n="@@delivery" class="tw-text-gray-800 ">Delivery</span>
                    <span class="tw-tracking-[1px] tw-gap-1 tw-flex ">
                      <del class="tw-tabular-nums   "> ₹{{100}}</del>
                      <span class="tw-text-orange-400 tw-tracking-normal tw-uppercase " i18n="@@free">free</span>
                    </span>
                  </div>
                  <div class="tw-absolute tw-w-[90%] tw-border-b-[1px] tw-border-dashed tw-border-gray-200 tw-left-1/2 tw-bottom-0 tw-transform -tw-translate-x-1/2 "></div>
                </div>
                <!--      Total container-->
                <div>
                  <!--        total payable-->
                  <div class="tw-py-3 tw-pb-4  tw-text-300 tw-font-semibold tw-flex tw-justify-between tw-items-center tw-px-4">
                    <h1 i18n="@@totalPayable">Total Payable</h1>
                    <h1 class=" tw-font-bold">₹{{totalSP}}</h1>
                  </div>
                  <!--        you are saving container-->
                  <div class=" cart-page-bill-savings-gradient tw-h-8 tw-rounded-b-2 tw-flex tw-justify-center tw-items-center">
                    <p class="tw-flex tw-pl-[2px] ">
                      <span class="tw-relative  tw-mr-[8px]">
                        <img class="tw-h-[16px]  tw-w-[16px] tw-rounded-full tw-shrink-0 tw-block tw-animate-spin_slow"
                          src="/assets/icons/percentageBgSavings.svg" alt="discount percentage  off bg"/>
                        <img class="tw-absolute tw-inset-0 tw-w-[5.98px] tw-h-[7.99px]  tw-shrink-0 tw-top-1 mx-auto"
                          src="/assets/icons/percentageSymbol.svg" alt="discount percentage off bg"/>
                      </span>
                      <span i18n="@@youAreSavingOnThisOrder">You are saving&nbsp;
              <span class="tw-text-teal-600  tw-font-bold">₹{{ totalMRP - (totalSP + (cashBalance ?? 0)) + (cashBalance ?? 0) }}</span>
              &nbsp;on this order</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        }
      </div>
    }
  </div>
  <ng-container>
    <!--  old cart sticky  view details -->
    @if (!showViewDetailedButtonContainer) {
      <div class="tw-shadow-z12 tw-flex tw-justify-between tw-items-center tw-p-[7px] tw-px-4 tw-h-8 tw-rounded-t-3 tw-font-body tw-bg-teal-100"
        >
        @if (!freeProductsArray.length) {
          <div >
            <span class="tw-text-200 tw-font-medium tw-capitalize tw-mr-[3px]" i18n="@@saved">saved</span>
            <span class="tw-text-200 tw-font-bold tw-text-teal-600">₹{{ totalMRP - (totalSP + (cashBalance ?? 0)) + (cashBalance ?? 0) }}</span>
          </div>
        }
        <div (click)="scrollToBottom()" class="tw-text-teal-600 tw-text-200 tw-font-bold flex tw-justify-end tw-items-center">
          <span i18n="@@viewDetailedBill">View Detailed Bill</span>
          <img src="/assets/icons/forward-right-chevron.svg" class="tw-w-6 tw-aspect-square">
        </div>
      </div>
    }
    <!--    old cart new Proceed to buy -->
    <div
      class="tw-w-full tw-px-4 tw-py-6 tw-h-[112px] tw-font-body tw-bg-white"
      (click)="checkout()"
      >
      <div class="tw-bg-teal-600 tw-h-12 tw-rounded-3 tw-text-white tw-flex tw-justify-center tw-items-center tw-relative">
        <div class="tw-text-400 tw-space-x-1 tw-items-center" [class.tw-ml-14]="discount > 5">
          <span class="tw-font-[700] tw-text-400 tw-leading-[20px]">
            <span [ngStyle]="{ 'font-size': user.get('languagePreference') === 'ta' || user.get('languagePreference') === 'ml' ? '12px' : '18px' }" i18n="@@buyNow">Buy Now</span><span> &#64; </span>
            @if (totalMRP !== totalSP) {
              <span class="tw-text-200  tw-line-through">₹{{totalMRP}}</span>
            }
            <span> ₹{{totalSP}}</span>
          </span>
        </div>
        <!--          discount percentage animation -->
        @if (discount && discount > 5) {
          <div class="tw-absolute tw-left-3 tw-top-[-10px] tw-flex  tw-items-center tw-justify-center">
            <div class="tw-relative">
              <img class="tw-h-[73px] tw-aspect-square tw-text-orange-400 tw-bg-transparent tw-rounded-full tw-shrink-0 tw-animate-spin_slow"
                src="/assets/icons/orange-discount.svg" alt="discount percentage off bg"/>
              <h1
                class="tw-text-white tw-absolute tw-inset-0 tw-rounded-full tw-break-all tw-flex tw-flex-col tw-justify-center tw-items-center tw-leading-none tw-font-bold tw-text-500 ">
                <span>{{discount}}%</span>
                <span class="tw-font-medium tw-font-body" [ngClass]="{'tw-text-300' : user.get('languagePreference') === appConfig.Shared.Languages.TA || user.get('languagePreference') === appConfig.Shared.Languages.TE}" i18n="@@off">Off</span>
              </h1>
            </div>
          </div>
        }
      </div>
      @if (experimentService.applyCashExperiment && cashBalance) {
        <p class="tw-text-100 tw-text-gray-500 tw-mt-2 tw-text-center tw-font-body" i18n="@@applyCashBalanceOnPaymentPage">
          Apply {{cashBalance}} Cure Cash <img class="tw-w-2.5 tw-aspect-square tw-inline-block tw-mb-0.5" src="/assets/images/cureskin-cash-icon.png" alt="cash" /> on payment page
        </p>
      }
    </div>
  </ng-container>
</div>
}
}

<!--no cart items UI-->
@if (noProductsInCart && !isLoading && !newCartUI) {
  @if (orderFlowHeader) {
    <div class="tw-flex tw-h-full tw-flex-col tw-bg-gray-100">
      <header class="tw-sticky tw-top-0 tw-z-40 tw-bg-white">
        <div class="tw-relative tw-flex tw-items-center tw-justify-center tw-px-6 tw-py-3">
          <div class="tw-absolute tw-left-6 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-text-gray-800" (click)="back()">
            <cs-icon class="tw-h-full tw-w-full" [iconName]="'arrow_left'"></cs-icon>
          </div>
          <h1 class="tw-text-center tw-text-300 tw-font-bold tw-capitalize tw-font-lexend tw-text-gray-800" i18n="@@yourCart">your cart</h1>
        </div>
      </header>
      <section class="tw-p-4">
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-2 tw-bg-white tw-py-6">
          <div class="tw-relative tw-mb-4 tw-flex tw-h-24 tw-w-24 tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100">
            <cs-icon class="tw-h-16 tw-w-16 tw-text-gray-800" [iconName]="'shopping_cart'"></cs-icon>
            <div class="tw-absolute tw-right-5 tw-top-5 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-shadow-z1">
              <span class="tw-text-300 tw-font-bold tw-font-body tw-text-orange-400">0</span>
            </div>
          </div>
          <h1 class="tw-mb-2 tw-text-200 tw-font-bold tw-font-body tw-text-gray-800" i18n="@@yourCartIsEmpty">Your Cart is Empty</h1>
          <button class="tw-flex tw-h-10 tw-w-50 tw-items-center tw-justify-center tw-rounded-2 tw-bg-teal-600 tw-text-300 tw-font-bold tw-font-body tw-text-white"
            (click)="goToShop()"
            i18n="@@startShopping"
          >Start Shopping</button>
        </div>
      </section>
    </div>
  } @else {
    <header class="tw-sticky tw-top-0 tw-z-40">
      <div class=" tw-flex tw-justify-between tw-items-end tw-bg-white tw-py-2 tw-pb-[10px] tw-px-[27px] tw-relative tw-h-[60px] tw-shadow-z4">
        <div class="tw-w-[16px] tw-aspect-square tw-flex tw-justify-center tw-items-center tw-absolute"  (click)="back()">
          <cs-icon class="tw-h-full tw-w-full tw-text-white"
          [iconName]="'back_new_icon'"></cs-icon>
        </div>
        <div class="tw-flex-1 tw-flex tw-justify-center tw-items-center">
          <h1 class="tw-text-center tw-text-300 tw-font-semibold tw-w-full tw-capitalize tw-font-body" i18n="@@yourCart">your cart</h1>
        </div>
      </div>
    </header>
    <section class="tw-w-full tw-pt-0 tw-p-4 tw-pb-6">
      <div class="tw-h-[232px] tw-bg-white tw-rounded-2 tw-flex tw-flex-col tw-justify-center tw-items-center">
        <img class="tw-h-[96px] tw-aspect-square tw-rounded-full tw-mb-4"
          src="/assets/icons/empty-cart-icon.svg" alt="empty cart"/>
        <h1 class="tw-text-200 tw-font-bold tw-mb-2 tw-text-gray-800" i18n="@@yourCartIsEmpty">Your Cart is Empty</h1>
        <button class="tw-bg-teal-600 tw-text-300 tw-text-white tw-h-10 tw-w-[200px] tw-font-bold tw-rounded-2 tw-flex tw-justify-center tw-items-center shine-button tw-font-body"
          (click)="goToShop()"
          i18n="@@startShopping"
        >Start Shopping</button>
      </div>
    </section>
  }
}


<!--new cart UI -->
@if (newCartUI && !isLoading) {
  <!-- new header-->
  <header class="tw-sticky tw-top-0 tw-z-40">
    <div class=" tw-flex tw-justify-between tw-items-end tw-bg-white tw-py-2 tw-pb-[10px] tw-px-[27px] tw-relative tw-h-[60px] tw-shadow-z4">
      <div class="tw-w-[16px] tw-aspect-square tw-flex tw-justify-center tw-items-center tw-absolute"  (click)="back()">
        <cs-icon class="tw-h-full tw-w-full tw-text-white"
        [iconName]="'back_new_icon'"></cs-icon>
      </div>
      <div class="tw-flex-1 tw-flex tw-justify-center tw-items-center">
        <h1 class="tw-text-center tw-text-300 tw-font-semibold tw-w-full tw-capitalize tw-font-body" i18n="@@yourCart">your cart</h1>
      </div>
    </div>
  </header>
  <div id="newCartUIContainer" class="tw-bg-gray-100 tw-h-screen tw-overflow-y-scroll tw-font-body tw-relative" [ngClass]="{'tw-pb-[120px]': (amountRemaining > 0) || newCartStickyBillDetails, 'tw-pb-[60px]': amountRemaining === 0 || !aovExp}">
    <!--    main content of cart page-->
    @if (!isLoading) {
      <div class="tw-pt-4 tw-pb-[180px]">
        <!--      no products UI-->
        @if (noProductsInCart) {
          <section class="tw-w-full tw-pt-0 tw-p-4 tw-pb-6">
            <div class="tw-h-[232px] tw-bg-white tw-rounded-2 tw-flex tw-flex-col tw-justify-center tw-items-center">
              <img class="tw-h-[96px] tw-aspect-square tw-rounded-full tw-mb-4"
                src="/assets/icons/empty-cart-icon.svg" alt="empty cart"/>
              <h1 class="tw-text-200 tw-font-bold tw-mb-2 tw-text-gray-800" i18n="@@yourCartIsEmpty">Your Cart is Empty</h1>
              <button class="tw-bg-teal-600 tw-text-300 tw-text-white tw-h-10 tw-w-[200px] tw-font-bold tw-rounded-2 tw-flex tw-justify-center tw-items-center shine-button tw-font-body"
                (click)="goToShop()"
                i18n="@@startShopping"
              >Start Shopping</button>
            </div>
          </section>
        }
        <!--      UI with products in cart-->
        @if (!noProductsInCart) {
          <section class="tw-bg-white tw-py-2 tw-rounded-2 tw-shadow-z4 tw-mb-6 tw-mx-4">
            <!--    total products in cart container-->
            <div class="tw-px-2">
              <div class="tw-rounded-t-2 cart-page-bg-gradient tw-p-2 tw-flex tw-justify-between tw-items-center tw-h-[48px]">
                <h1 class="tw-text-300 tw-font-bold">
                  <span>{{totalProducts}}&nbsp;</span>
                  <span i18n="@@products">Products</span>
                </h1>
                @if (showSavedText) {
                  <div class="tw-text-teal-600 tw-flex tw-justify-end tw-items-center tw-gap-[2px]">
                    <div class="tw-relative tw-mr-[2px]">
                      <img class="tw-h-[16px] tw-w-[16px] tw-rounded-full tw-shrink-0 tw-block tw-animate-spin_slow"
                        src="/assets/icons/percentageBgSavings.svg" alt="discount percentage off bg"/>
                      <img class="tw-absolute tw-inset-0 tw-w-[5.98px] tw-h-[7.99px] tw-shrink-0 tw-top-1 mx-auto"
                        src="/assets/icons/percentageSymbol.svg" alt="discount percentage off bg"/>
                    </div>
                    <h3 class="tw-text-200 tw-font-medium tw-mt-[1px] tw-uppercase" i18n="@@saved">saved</h3>
                    <h3 class="tw-text-300 tw-font-bold">₹{{ totalMRP - (totalSP + (cashBalance ?? 0)) + (cashBalance ?? 0) }}</h3>
                  </div>
                }
              </div>
            </div>
            <!--  free products container-->
            @for (item of freeProductsArray; track item; let i = $index) {
              <div class="tw-py-2 tw-flex tw-border-b tw-border-b-gray-100" [ngClass]="{'tw-hidden': item?.price}">
                <div class="tw-p-[8px] tw-pt-[8px] tw-pr-4 tw-pb-2 tw-pl-[12px] tw-flex-shrink-0">
                  <div class="tw-relative tw-rounded-1 tw-overflow-hidden">
                    <img class="tw-w-[78px] tw-rounded-1 tw-overflow-hidden tw-object-cover"
                      (click)="viewProductDetail(item)"
                      [src]="item.rebrandedImageWithBackground || item.rebrandedImage || item.rebrandedImageWithoutBackground || item.imageURL" />
                    <div class="tw-absolute tw-bottom-0 tw-right-0 tw-left-0">
                      @if (item?.isDoctorAdded) {
                        <div class="tw-flex tw-justify-center tw-items-center tw-gap-[2px] tw-bg-orange-100 tw-text-orange-400"
                          >
                          <cs-icon class="tw-h-2 tw-w-2 tw-text-orange-400 tw-bg-transparent tw-rounded-full tw-shrink-0"
                          [iconName]='"thickTickIcon"'></cs-icon>
                          <p class="tw-font-body tw-text-orange-400 tw-text-50 tw-font-medium tw-whitespace-nowrap" i18n="@@drAdded">
                  Dr. Added
                </p>
                        </div>
                      }
                    </div>
                    <div class="tw-absolute tw-top-0 tw-left-0 tw-w-[34px] tw-h-[34px]">
                      <img class="w-full h-full"
                        src="/assets/icons/free-gift-bg.svg" alt="free-gift"/>
                    </div>
                  </div>
                </div>
                <div class="tw-py-2 tw-pr-2 tw-w-full">
                  <div class="flex tw-items-start tw-justify-between tw-pt-3 tw-mb-[14px]">
                    <h1 class="tw-text-200">{{item?.product?.title || item?.title}}</h1>
                  </div>
                  <div>
                    <p class="tw-text-gray-400 tw-text-100 tw-font-medium">
                      <span>{{item?.quantity}}</span>
                      <span class="tw-ml-0.5" i18n="@@freeUnit">unit</span>
                    </p>
                    <div class="tw-flex tw-justify-between">
                      <div class="tw-w-max">
                        <div class="tw-flex tw-flex-col xs:tw-flex-row-reverse xs:tw-items-center tw-gap-1 tw-font-body tw-mt-1">
                          <span class="tw-text-500 tw-font-bold tw-text-orange-500 tw-block tw-leading-[16px] tw-font-body tw-uppercase" i18n="@@free">free</span>
                          <del class="tw-text-200 tw-text-gray-500 tw-block tw-font-body">₹{{ item.mrp }}</del>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <!--   non free products container-->
            @for (item of cartItems.slice().reverse(); track item; let i = $index) {
              <div class="tw-py-2 tw-flex tw-h-[128px]"
           [ngClass]="{
                      'tw-border-b tw-border-b-gray-100': cartItems.length !== i + (aovExp ? freeProductsArray.length ? freeProductsArray.length: freeProductsArray.length  + 1 : 1),
                      'tw-hidden': !item?.price
  }">
                <div class="tw-p-[8px] tw-pt-[8px] tw-pr-4 tw-pb-2 tw-pl-[12px] tw-flex-shrink-0">
                  <div class="tw-relative tw-rounded-1 tw-overflow-hidden">
                    <img class="tw-w-[78px] tw-rounded-1 tw-overflow-hidden tw-object-cover"
                      (click)="viewProductDetail(item)"
                      [src]="item.rebrandedImageWithBackground || item.rebrandedImage || item.rebrandedImageWithoutBackground || item.imageURL" />
                    <div class="tw-absolute tw-bottom-0 tw-right-0 tw-left-0">
                      @if (item?.isDoctorAdded) {
                        <div class="tw-flex tw-justify-center tw-items-center tw-gap-[2px] tw-bg-orange-100 tw-text-orange-400"
                          >
                          <cs-icon class="tw-h-2 tw-w-2 tw-text-orange-400 tw-bg-transparent tw-rounded-full tw-shrink-0"
                          [iconName]='"thickTickIcon"'></cs-icon>
                          <p class="tw-font-body tw-text-orange-400 tw-text-50 tw-font-medium tw-whitespace-nowrap" i18n="@@drAdded">
                  Dr. Added
                </p>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="tw-pr-4 tw-w-full tw-flex tw-flex-col tw-justify-between tw-py-1 tw-pb-2">
                  <div class="tw-flex tw-items-start tw-justify-between tw-pt-[7px]">
                    <div class="tw-text-200 tw-w-full">{{item?.product?.title || item?.title}}</div>
                    <div class="tw-w-5">
                      <cs-icon (click)='removeProduct(item, "DELETE", $event)' class="tw-text-white tw-h-4 tw-translate-y-0 tw-mr-[-4px]"
                      [iconName]="'delete_icon_product_card'"></cs-icon>
                    </div>
                  </div>
                  <div>
                    <div class="tw-mb-2">
                      <p class="tw-text-gray-400 tw-text-100 tw-font-medium">{{item?.quantityData}}</p>
                    </div>
                    <div class="tw-flex tw-justify-between tw-pb-[4.2px]">
                      <div class="tw-h-6 tw-w-[78px] tw-border tw-border-teal-600 tw-rounded-[6px] tw-flex tw-justify-between tw-items-center tw-px-2 tw-text-teal-600 tw-text-200 tw-font-bold tw-font-body">
                        <span class="font-plus-minus" (click)="removeProduct(item, 'REMOVE', $event)">-</span>
                        <span>{{ item?.quantity }}</span>
                        <span class="font-plus-minus" (click)=' addOrRemove(item, "ADD", $event)'>+</span>
                      </div>
                      <div class="tw-w-max tw-mt-1 -tw-mr-1">
                        @if (item.mrp !== item.price) {
                          <div class="tw-flex tw-flex-row-reverse xs:tw-items-center tw-gap-1 tw-font-body">
                            <span class="tw-text-400 tw-font-bold tw-text-orange-500 tw-block tw-leading-[16px] tw-font-body">₹{{ item.price }}</span>
                            <del class="tw-text-200 tw-text-gray-500 tw-block tw-font-body">₹{{ item.mrp }}</del>
                          </div>
                        }
                        @if (item.mrp === item.price) {
                          <div>
                            <span class="tw-text-400 tw-font-bold tw-text-orange-500 tw-block tw-leading-[16px] tw-font-body">₹{{ item.price }}</span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </section>
        }
        <!--      products you may need -->
        @if (cart?.productsYouMayNeed?.length) {
          <section class="tw-h-[192px] cart-page-products-you-may-need-gradient tw-mb-8 tw-p-4 tw-pt-[19px] tw-px-0">
            <h1 class="tw-font-bold tw-text-300  tw-font-body tw-pb-[11px] tw-px-[18px]" i18n="@@productsYouMayNeed">Products You May Need</h1>
            <div class="tw-h-[128px] tw-flex tw-gap-2 tw-overflow-x-auto tw-px-[16px]">
              @for (item of cart?.productsYouMayNeed; track item; let i = $index) {
                <div class="tw-py-3 tw-px-2 tw-w-[252px] tw-h-[120px] tw-bg-white tw-shadow-z4 tw-gap-[6.5px] tw-shrink-0 tw-rounded-2 tw-flex">
                  <img
                    (click)="viewProductDetail(item)"
                    [src]="item.rebrandedImageWithBackground || item.rebrandedImage || item.rebrandedImageWithoutBackground || item.imageURL"
                    class="tw-w-[78px] tw-shrink-0 tw-rounded-1 tw-object-cover"
                    />
                  <div class="tw-flex tw-flex-col tw-flex-1 tw-justify-between">
                    <div>
                      @if (item?.tag) {
                        <h2 class="cart-page-tag-bg-gradient tw-h-4 tw-w-[78px] tw-text-50 tw-pl-[5px] tw-font-medium tw-rounded-1 tw-mb-1">{{item?.tag}}</h2>
                      }
                      <h1 class="tw-text-gray-800 tw-text-200">{{item?.product?.title || item?.title}}</h1>
                    </div>
                    <div class="tw-flex tw-justify-between tw-items-center">
                      <div>
                        <span class="tw-text-400 tw-font-bold tw-block tw-leading-[16px] tw-font-body tw-text-orange-500 tw-mt-[1px]">₹{{ item.price }}</span>
                        <del class="tw-text-gray-400 tw-block tw-font-body tw-text-200 ">₹{{ item.mrp }}</del>
                      </div>
                      <div class="tw-bg-teal-600 tw-w-[80px] tw-h-8 tw-text-white tw-text-300 tw-font-bold tw-flex tw-justify-center tw-items-center tw-rounded-3 tw-mb-[2px]" (click)='addSingleProductToCart(item?.productId)' i18n="@@add">Add</div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </section>
        }
        @if (newCartStickyBillDetails && !noProductsInCart) {
          <div class="tw-shadow-z4">
            <app-aov-banner
              [amountRemaining]="amountRemaining"
              [freeProductBannerImage]="freeProductImageForAov"
              [percentageDone]="aovBannerPercentageDone"
              [isEnglishLanguage]="user?.get('languagePreference') === appConfig.Shared.Languages.EN"
              [displayInCartPage] = true
            ></app-aov-banner>
          </div>
        }
        <!--  bill details container-->
        @if (!noProductsInCart && !newCartStickyBillDetails) {
          <section #billDetailsContainer class="tw-rounded-2 tw-shadow-z4 tw-bg-white tw-pt-5 tw-mx-4">
            <!--    section title-->
            <div class="tw-flex tw-gap-[6px] tw-relative tw-pb-3 tw-px-4">
              <cs-icon class="tw-h-5 tw-aspect-square tw-text-white"
              [iconName]="'bill_icon'"></cs-icon>
              <h1 class="tw-text-300 tw-font-bold" i18n="@@billDetails">Bill Details</h1>
              <div class="tw-absolute tw-w-[90%] tw-border-b-[1px] tw-border-dashed tw-border-gray-200 tw-left-1/2 tw-bottom-0 tw-transform tw-translate-y-[1px] -tw-translate-x-1/2"></div>
            </div>
            <!--    details container-->
            <div class="tw-text-200 tw-pt-[2px] tw-font-body">
              <!--      sub details container-->
              <div class="tw-py-3 tw-px-4 tw-relative">
                <!--      subtotal-->
                <div class="tw-flex tw-justify-between tw-mb-2 tw-items-center">
                  <span i18n="@@subtotal" class="tw-text-gray-800 ">Subtotal</span>
                  <span class="tw-tabular-nums ">₹{{totalMRP}}</span>
                </div>
                <!--      Discount-->
                <div class="tw-flex tw-justify-between tw-mb-2 tw-items-center">
                  <span i18n="@@discount" class="tw-text-gray-800">Discount</span>
                  <div class="tw-flex tw-text-orange-500 tw-items-center">
                    @if (!showCashBalance) {
                      <span class="tw-tabular-nums tw-tracking-[1px]">- ₹{{totalMRP - totalSP}}</span>
                    }
                    @if (showCashBalance) {
                      <span class="tw-tabular-nums tw-tracking-[1px]">- ₹{{totalMRP - (totalSP + cashBalance)}}</span>
                    }
                  </div>
                </div>
                <!--      Cureskin Cash-->
                @if (showCashBalance) {
                  <div class="tw-flex tw-justify-between tw-mb-2 tw-items-center"
                    >
                    <span class="tw-flex ">
                      <span i18n="@@cureskinCash" class="tw-text-gray-800">Cure Cash</span>
                      <img class="tw-w-4 tw-ml-1 tw-h-4" src="/assets/images/cureskin-cash-icon.png" />
                    </span>
                    <span class="tw-tracking-[1px] tw-text-orange-500 tw-tabular-nums">-
                    ₹{{cashBalance}}</span>
                  </div>
                }
                <!--      Delivery-->
                <div class="tw-flex tw-items-center tw-justify-between">
                  <span i18n="@@delivery" class="tw-text-gray-800">Delivery</span>
                  <span class="tw-tracking-[1px] tw-gap-1 tw-flex">
                    <del class="tw-tabular-nums"> ₹{{100}}</del>
                    <span class="tw-text-orange-400 tw-tracking-normal tw-uppercase" i18n="@@free">free</span>
                  </span>
                </div>
                <div class="tw-absolute tw-w-[90%] tw-border-b-[1px] tw-border-dashed tw-border-gray-200 tw-left-1/2 tw-bottom-0 tw-transform -tw-translate-x-1/2"></div>
              </div>
              <!--      Total container-->
              <div>
                <!--        total payable-->
                <div class="tw-py-3 tw-pb-4 tw-text-300 tw-font-semibold tw-flex tw-justify-between tw-items-center tw-px-4">
                  <h1 i18n="@@totalPayable">Total Payable</h1>
                  <h1 class="tw-font-bold">₹{{totalSP}}</h1>
                </div>
                <!--        you are saving container-->
                <div class="cart-page-bill-savings-gradient tw-h-8 tw-rounded-b-2 tw-flex tw-justify-center tw-items-center">
                  <p class="tw-flex tw-pl-[2px]">
                    <span class="tw-relative tw-mr-[8px]">
                      <img class="tw-h-[16px] tw-w-[16px] tw-rounded-full tw-shrink-0 tw-block tw-animate-spin_slow"
                        src="/assets/icons/percentageBgSavings.svg" alt="discount percentage off bg"/>
                      <img class="tw-absolute tw-inset-0 tw-w-[5.98px] tw-h-[7.99px] tw-shrink-0 tw-top-1 mx-auto"
                        src="/assets/icons/percentageSymbol.svg" alt="discount percentage off bg"/>
                    </span>
                    <span i18n="@@youAreSavingOnThisOrder">You are saving&nbsp;
              <span class="tw-text-teal-600 tw-font-bold">₹{{ totalMRP - (totalSP + (cashBalance ?? 0)) + (cashBalance ?? 0) }}</span>
              &nbsp;on this order</span>
                  </p>
                </div>
              </div>
            </div>
          </section>
        }
        @if (newCartStickyBillDetails) {
          <div class="tw-h-32"></div>
        }
      </div>
    }
    <!--        bottom sticky container-->
    @if (!isLoading && !noProductsInCart) {
      <section id="bottomStickyContainer" class="tw-fixed tw-z-[11] tw-bottom-0 tw-w-full tw-shadow-z8 tw-rounded-t-3">
        <!-- new sticky bill details container-->
        @if (!noProductsInCart && newCartStickyBillDetails) {
          <section class="tw-rounded-t-2 tw-bg-[rgba(256,256,256,0.75)] tw-backdrop-blur-sm">
            <!--    details container-->
            <div class="tw-font-body tw-text-200 tw-pt-[2px]">
              <!--      sub details container-->
              <div class="tw-py-3 tw-relative tw-px-4">
                <!--      subtotal-->
                <div class="tw-flex tw-justify-between tw-items-center tw-mb-2">
                  <span class="tw-text-gray-800" i18n="@@subtotal">Subtotal</span>
                  <span class="tw-tabular-nums">₹{{totalMRP}}</span>
                </div>
                <!--      Discount-->
                <div class="tw-flex tw-justify-between tw-items-center tw-mb-2">
                  <span class="tw-text-gray-800" i18n="@@discount">Discount</span>
                  <div class="tw-flex tw-items-center tw-text-orange-500">
                    @if (!showCashBalance) {
                      <span class="tw-tracking-[1px] tw-tabular-nums">- ₹{{totalMRP - totalSP}}</span>
                    }
                    @if (showCashBalance) {
                      <span class="tw-tracking-[1px] tw-tabular-nums">- ₹{{totalMRP - (totalSP + cashBalance)}}</span>
                    }
                  </div>
                </div>
                <!--      Cureskin Cash-->
                @if (showCashBalance) {
                  <div class="tw-flex tw-justify-between tw-items-center tw-mb-2"
                    >
                    <span class="tw-flex">
                      <span class="tw-text-gray-800" i18n="@@cureskinCash">Cure Cash</span>
                      <img class="tw-w-4 tw-h-4 tw-ml-1" src="/assets/images/cureskin-cash-icon.png" />
                    </span>
                    <span class="tw-tracking-[1px] tw-tabular-nums tw-text-orange-500">-
                    ₹{{cashBalance}}</span>
                  </div>
                }
                <!--      Delivery-->
                <div class="tw-flex tw-justify-between tw-items-center">
                  <span class="tw-text-gray-800" i18n="@@delivery">Delivery</span>
                  <span class="tw-tracking-[1px] tw-flex tw-gap-1">
                    <span class="tw-text-orange-400 tw-tracking-normal" i18n="@@free">free</span>
                    <del class="tw-tabular-nums"> ₹{{100}}</del>
                  </span>
                </div>
                <div class="tw-absolute tw-w-[90%] tw-border-b-[1px] tw-border tw-border-gray-200 tw-left-1/2 tw-bottom-0 tw-transform -tw-translate-x-1/2"></div>
              </div>
              <!--      Total container-->
              <div>
                <!--        total payable-->
                <div class="tw-py-3 tw-pb-4 tw-text-300 tw-font-semibold tw-flex tw-justify-between tw-items-center tw-px-4">
                  <h1 i18n="@@grandTotal">Grand Total</h1>
                  <h1 class="tw-font-bold">₹{{totalSP}}</h1>
                </div>
              </div>
            </div>
          </section>
        }
        <!--      AOV remaining banner-->
        @if (!newCartStickyBillDetails) {
          <app-aov-banner
            [amountRemaining]="amountRemaining"
            [freeProductBannerImage]="freeProductImageForAov"
            [percentageDone]="aovBannerPercentageDone"
            [isEnglishLanguage]="user?.get('languagePreference') === appConfig.Shared.Languages.EN"
          ></app-aov-banner>
        }
        @if (!showViewDetailedButtonContainer && (aovExp ? amountRemaining === 0 : true) && !newCartStickyBillDetails) {
          <div class="tw-flex tw-justify-between tw-items-center tw-p-[7px] tw-px-4 tw-h-8 tw-bg-teal-100 tw-rounded-t-3">
            @if (!freeProductsArray.length) {
              <h3 class="tw-uppercase tw-text-100 tw-tracking-[1.7px]" i18n="@@freeDelivery">Free Delivery</h3>
            }
            @if (freeProductsArray.length &&  amountRemaining === 0) {
              <h3 class="tw-uppercase tw-text-100 tw-tracking-[1.7px]" i18n="@@freePouchAOV">Free Gift</h3>
            }
            <div (click)="scrollToBottom()" class="tw-text-teal-600 tw-text-200 tw-font-bold flex tw-justify-end tw-items-center">
              <span i18n="@@viewDetailedBill">View Detailed Bill</span>
              <img src="/assets/icons/forward-right-chevron.svg" class="tw-w-6 tw-aspect-square">
            </div>
          </div>
        }
        <div
          class="tw-w-full tw-px-4 tw-py-6 tw-h-[112px]"
          [ngClass]="{'tw-bg-white': !newCartStickyBillDetails, 'tw-bg-teal-100': newCartStickyBillDetails}"
          (click)="checkout()"
          >
          <div class="tw-bg-teal-600 tw-h-12 tw-rounded-3 tw-text-white tw-flex tw-justify-center tw-items-center tw-relative">
            <div class="tw-text-400 tw-space-x-1 tw-items-center" [class.tw-ml-14]="discount > 5">
              @if (!newCartStickyBillDetails) {
                <span class="tw-capitalize" i18n="@@ClickToPay">Click to Pay</span>
                <del>₹{{totalMRP}}</del>
                <span class="tw-text-500 tw-font-bold">₹{{totalSP}}</span>
              }
              @if (newCartStickyBillDetails) {
                <span class="tw-font-bold" i18n="@@proceedToBuy">Proceed to Buy</span>
              }
            </div>
            @if (discount && discount > 5) {
              <div class="tw-absolute tw-left-3 tw-top-[-10px] tw-flex  tw-items-center tw-justify-center">
                <div class="tw-relative">
                  @if (!newCartStickyBillDetails) {
                    <img class="tw-h-[73px] tw-aspect-square tw-text-orange-400 tw-bg-transparent tw-rounded-full tw-shrink-0"
                      src="/assets/icons/discountBg.svg" alt="discount percentage off bg"/>
                  }
                  @if (newCartStickyBillDetails) {
                    <img class="tw-h-[73px] tw-aspect-square tw-text-orange-400 tw-bg-transparent tw-rounded-full tw-shrink-0"
                      src="/assets/images/star_circle_orange.png" alt="discount percentage off bg"/>
                  }
                  <h1
                    [ngClass]="{'tw-text-white': newCartStickyBillDetails, 'tw-text-orange-500': !newCartStickyBillDetails}"
                    class="tw-absolute tw-inset-0 tw-rounded-full tw-break-all tw-flex tw-flex-col tw-justify-center tw-items-center tw-leading-none tw-font-bold tw-text-500 -tw-translate-y-0.5">
                    <span>{{discount}}%</span>
                    <span class="tw-font-medium tw-font-body" [ngClass]="{'tw-text-300' : user.get('languagePreference') === appConfig.Shared.Languages.TA || user.get('languagePreference') === appConfig.Shared.Languages.TE}" i18n="@@off">Off</span>
                  </h1>
                </div>
              </div>
            }
          </div>
        </div>
      </section>
    }
  </div>
}
@if (isDiscontinued) {
  <pop-up
    [class]="'bdr-rad-10 p15 popup-ht-unset'"
    [show]="isDiscontinued"
    [triggerDismiss]="true"
    (close)="closePopup()">
    <discontinued-popup [oldProductData]="oldProduct"
      [newProductData]="newProduct"
      (changeProduct)="changeProduct($event)"
    (articleOpen)="openArticle()"></discontinued-popup>
  </pop-up>
}

<ng-template #orderFlowFreeProductCard>
  <div class="tw-mx-4 tw-mb-3">
    <app-cart-free-product-card
      [image]="freeProductImageForAov"
      [title]="freeProduct?.title"
      [quantityLabel]="freeProductQuantityLabel"
      [mrp]="freeProduct?.mrp"></app-cart-free-product-card>
  </div>
</ng-template>

<ng-template #orderFlowProductCard let-item="item">
  @if (item?.price !== 0) {
    <div class="tw-mx-4 tw-mb-3">
      <app-cart-product-card
        [item]="item"
        [nonRxLimit]="nonRxLimit"
        [rxLimit]="rxLimit"
        (viewDetail)="viewProductDetail(item)"
        (increment)="addOrRemove(item, 'ADD')"
        (decrement)="removeProduct(item, 'REMOVE')"
        (remove)="removeProduct(item, 'DELETE')"></app-cart-product-card>
    </div>
  }
</ng-template>
